import * as IdGenerator from 'auth0-id-generator';

/*
 * Generate a key for the database.
 */
export function genID(prefix?: string): string {
  const generator = new IdGenerator();
  return prefix ? generator.new(prefix) : generator.newUid(10);
}
